export const translations = {
  FULLSCREEN: {
    ES: "PANTALLA COMPLETA",
    EN: "FULLSCREEN",
  },
  NORMALSCREEN: {
    ES: "PANTALLA NORMAL",
    EN: "NORMAL SCREEN",
  },
  "ACTIVE SOUND": {
    ES: "SONIDO ACTIVO",
    EN: "ACTIVE SOUND",
  },
  "DEACTIVE SOUND": {
    ES: "SONIDO DESACTIVADO",
    EN: "DEACTIVE SOUND",
  },
  PLAY: {
    ES: "PLAY",
    EN: "PLAY",
  },
  PAUSE: {
    ES: "PAUSA",
    EN: "PAUSE",
  },
  "Watch Video": {
    en: "Watch Video",
    es: "Ver vídeo",
  },
  // Add more keys as needed
};
